<div>
  <form [formGroup]="SettingsForm">
    <div class="col-lg-12">
      <div class="mb-3 row">
        <fieldset>
          <legend>Basic Settings</legend>
        </fieldset>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="mb-3 row">
        <div class="col-lg-8">
          <span style="margin-left: 20px; margin-right: 5px;">Name:</span>
          <input type="text" pInputText style="width: 250px;" [formControl]="name" />
        </div>
        <div class="col-lg-2">
          <input type="checkbox" [formControl]="enabled" />
          <span class="uv-checkbox-label">Enabled</span>
        </div>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="mb-3 row">
        @if (name.hasError('required')) {
        <div class="col-lg-8 alert alert-danger" style="margin-left: 20px;">
          This value is required
        </div>
        }
      </div>
    </div>
    <div class="col-lg-12">
      <div class="mb-3 row">
        <fieldset>
          <legend>PRTG Target Server / Credentials</legend>
        </fieldset>
      </div>
    </div>
    <div class="form-group row">
      <div class="uv-row">
        <div
          style="display: grid; grid-template-columns: auto auto; margin-left: 20px; column-gap: 10px; row-gap: 10px;">
          <span>Target:</span>
          <div style="width: 250px;">
            <select [formControl]="prtgTargetGUID" [ngClass]="{'show-error':prtgTargetGUID.hasError('required')}"
              (change)="onPrtgTargetChange()" style="width: 200px; margin-right: 10px;">
              @for (settings of prtgSettings; track settings) {
              <option value="{{settings.GUID}}">{{settings.Name}}</option>
              }
            </select>
            <info width="350px">Specify the target PRTG server by selecting one of the network's PRTG credentials.
            </info>
            @if (prtgTargetGUID.hasError('required')) {
            <div class="col-lg-3 alert alert-danger" style="width: 200px;">This value is required</div>
            }
          </div>
          <span>Server URL:</span>
          <input type="text" pInputText style="width: 500px;" [formControl]="prtgTarget" />
          <span>Username:</span>
          <input type="text" pInputText style="width: 250px;" [formControl]="prtgUsername" />
          <span>Passhash:</span>
          <input type="text" pInputText style="width: 250px;" [formControl]="prtgPasshash" />
        </div>
      </div>
    </div>
  </form>
  <div class="mb-3"></div>
</div>